// multiFileSelect.js - API service for multi-file selection
import { fetchWithAuth } from "../apiutil";

export const multiFileSelectAPI = {
  selectFilteredFile: async (accessToken, caseId, clipId, audioFile) => {
    console.log(
      `[multiFileSelectAPI.selectFilteredFile] Selecting file for noise filtering: ${audioFile.id} in case ${caseId}, clip ${clipId}`,
    );
    return fetchWithAuth(
      `/api/cases/${caseId}/clips/${clipId}/selectFromMultipleFiles/${audioFile.id}`,
      { method: "POST" },
      accessToken,
    );
  },
};
